enum LeadActionsEnum {
    DealAdd = 'LEAD/DEAL/ADD',
    DealComplete = 'LEAD/DEAL/COMPLETE',
    DealErrorSet = 'LEAD/DEAL/ERROR/SET',
    DealGet = 'LEAD/DEAL/GET',
    DealSend = 'LEAD/DEAL/SEND',
    DealSet = 'LEAD/DEAL/SET',
    DealValueSet = 'LEAD/DEAL/VALUE/SET',

    DealAddressSearch = 'LEAD/ADDRESS_SEARCH/SEARCH',
    DealAddressSearchResultsSet = 'LEAD/ADDRESS_SEARCH/SEARCH/RESULTS/SET',
    DealAddressSearchResultsClear = 'LEAD/ADDRESS_SEARCH/SEARCH/RESULTS/CLEAR',

    DealsList = 'DEALS/LIST',
    DealsSet = 'DEALS/SET',

    DealQuotesList = 'LEAD/QUOTES/LIST',
    DealQuotesSet = 'LEAD/QUOTES/SET',

    PropertiesAdd = 'LEAD/PROPERTIES/ADD',

    PropertyDelete = 'LEAD/PROPERTY/DELETE',
    PropertyGnafAddressDetail = 'LEAD/PROPERTY/GNAF_ADDRESS_DETAIL',
    PropertyGnafAddressDetailLoadingClear = 'LEAD/PROPERTY/GNAF_ADDRESS_DETAIL/LOADING_CLEAR',
    PropertyErrorSet = 'LEAD/PROPERTY/ERROR/SET',
    PropertySend = 'LEAD/PROPERTY/SEND',
    PropertySet = 'LEAD/PROPERTY/SET',
    PropertyValueSet = 'LEAD/PROPERTY/VALUE/SET',
}

export default LeadActionsEnum;
